import React from "react";
import ImgContainer from "@/components/ImgContainer";
import { Tooltip } from "antd";
import { Link } from "react-router-dom";
import "./style.less";

interface VideoCardProps {
  className: string;
  cover: string;
  title: string;
  profile: string;
  url: string;
  duration?: string;
  style?: object;
  theme: "dark" | "hight";
  height: number;
  rows?: number;
}

function VideoCard(props: VideoCardProps) {
  const { height = 100, rows = 2 } = props;

  return (
    <div
      className={`com-videoCard flex ${props.className}`}
      style={props.style}
    >
      {props.url ? (
        <Link
          to={props.url}
          target="_blank"
          className="com-videoCard__cover nozoom"
        >
          <ImgContainer
            src={props.cover}
            width={height / (10 / 16)}
            scale={10 / 16}
          />
          {props.duration && (
            <span className="com-videoCard__duration">{props.duration}</span>
          )}
        </Link>
      ) : (
        <div className="com-videoCard__cover nozoom">
          <ImgContainer
            src={props.cover}
            width={height / (10 / 16)}
            scale={10 / 16}
          />
          {props.duration && (
            <span className="com-videoCard__duration">{props.duration}</span>
          )}
        </div>
      )}
      <div className="com-videoCard__info">
        <Tooltip title={props.title}>
          {props.url ? (
            <Link
              to={props.url}
              target="_blank"
              className={`com-videoCard__title nowrap-ellipsis ${
                props.theme || "dark"
              }-primary font-size-14`}
            >
              {props.title}
            </Link>
          ) : (
            <div
              className={`com-videoCard__title nowrap-ellipsis ${
                props.theme || "dark"
              }-primary font-size-14`}
            >
              {props.title}
            </div>
          )}
        </Tooltip>
        <p
          className={`com-videoCard__profile ${
            props.theme || "dark"
          }-disable font-size-12 nowrap--ellipsis-${rows}`}
        >
          {props.profile}
        </p>
      </div>
    </div>
  );
}

export default VideoCard;
